import cx from 'classnames'

import { Checkbox } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import { withDivider } from '../../utils'

import styles from './item.module.scss'

export function NotIgao ({ item, handleChangeResponse, prevItem }) {
  const { filters } = useIGAO()
  const answerDiff = item?.diff?.answer
  const changedBothAnswer = answerDiff?.current && answerDiff?.previous
  const newValue = !changedBothAnswer
    ? answerDiff?.current || answerDiff?.previous
    : null

  const renderCheckBoxContainer = () => {
    const bodyStyle = {
      borderRadius: '10px',
      display: 'flex'
    }
    const renderCheckBox = () => {
      const style = {
        width: '60px',
        padding: '8px',
        borderRadius: '10px'
      }
      return (
        <>
          <div
            id={item.id}
            style={{ ...style }}
            className={cx({ [styles.diff]: newValue === 'yes' })}
          >
            <Checkbox
              label='Yes'
              onChange={() => handleChangeResponse(item.id, 'yes')}
              round
              value={item.answer === 'yes'}
              labelClassName={styles.igaoLabel}
            />
          </div>
          <div
            style={style}
            className={cx({ [styles.diff]: newValue === 'no' })}
          >
            <Checkbox
              label='No'
              onChange={() => handleChangeResponse(item.id, 'no')}
              round
              value={item.answer === 'no'}
              labelClassName={styles.igaoLabel}
            />
          </div>
        </>
      )
    }

    if (changedBothAnswer) {
      return (
        <div
          style={bodyStyle}
          className={cx({ [styles.diff]: Object.prototype.hasOwnProperty.call(item?.diff ?? {}, 'answer') })}
        >
          {renderCheckBox()}
        </div>
      )
    }
    return renderCheckBox()
  }

  return (
    <>
      {withDivider(prevItem, filters)}
      <div className={styles.itemWrap}>
        <div className={styles.item}>
          <div className={styles.innerBody}>
            <div className={styles.itemLabel}>
              <span>{item?.label}</span>
            </div>
          </div>
          {renderCheckBoxContainer()}
        </div>
      </div>
    </>
  )
}
